
import { defineComponent } from "vue";
import Utility from "@/assets/common/scripts/utility";

export default defineComponent({
  name: "PaymentMethod",
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    getMethod: {
      type: String,
      default: "",
    },
    arrivalDate: {
      type: String,
    },
    departureDate: {
      type: String,
    },
  },
  created() {
    this.selectedPayMethod = this.modelValue;
  },
  watch: {
    modelValue: function (newVal) {
      this.selectedPayMethod = newVal;
    },
  },
  computed: {
    getMethodClass: function () {
      return function (selectVal: string, val: string) {
        if (selectVal === val) {
          return "method_checked";
        } else {
          return "method_nocheck";
        }
      };
    },
  },
  methods: {
    methodClick(val: string): void {
      this.selectedPayMethod = val;
      this.$emit("update:modelValue", val);
    },
    calculateTravelingDays(departureDate: string, arrivalDate: string): number {
      if (!departureDate || !arrivalDate) return 0;
      return parseInt(
        Utility.calculateTravelingDays(departureDate, arrivalDate)
      );
    },
  },
  data() {
    return {
      selectedPayMethod: "3",
    };
  },
});
